import { Alert, AlertIcon, Box, Heading, Text, VStack } from "@chakra-ui/react";
import DynamicField from "../DynamicField";

/**
 * Returns the list of field labels that are required-but-unfilled. A
 * field counts as filled if its value is anything other than null /
 * undefined. An empty string is considered "skipped" (the `Skip`
 * checkbox sets that) — it satisfies the gate.
 */
export function getMissingRequiredFields(config, fieldValues) {
  return (config?.fields || [])
    .filter((f) => f.required)
    .filter((f) => {
      const v = fieldValues?.[f.key];
      if (v === undefined || v === null) return true;
      if (Array.isArray(v) && v.length === 0) return true;
      return false; // "" counts as skipped → allowed
    })
    .map((f) => f.label);
}

export default function Step3BusinessDetails({
  config,
  fieldValues,
  onFieldChange,
}) {
  if (!config) {
    return <Text>Pick a use case first.</Text>;
  }

  const fields = config.fields || [];
  const unfilledRequired = getMissingRequiredFields(config, fieldValues);

  return (
    <VStack spacing={6} align="stretch">
      <VStack spacing={1} textAlign="center">
        <Heading size="lg">Your business details</Heading>
        <Text color="gray.600">
          We've filled in what we could from your description. Edit anything
          that's not quite right.
        </Text>
      </VStack>

      {unfilledRequired.length > 0 && (
        <Alert status="warning" borderRadius="md">
          <AlertIcon />
          <Box fontSize="sm">
            Please fill (or skip) the required fields:{" "}
            <strong>{unfilledRequired.join(", ")}</strong>.
          </Box>
        </Alert>
      )}

      <VStack spacing={5} align="stretch">
        {fields.map((field) => (
          <DynamicField
            key={field.key}
            field={field}
            value={fieldValues[field.key]}
            onChange={onFieldChange}
          />
        ))}
      </VStack>
    </VStack>
  );
}
